import { render, staticRenderFns } from "./CustomGroups.vue?vue&type=template&id=53dd6c77"
import script from "./CustomGroups.vue?vue&type=script&lang=js"
export * from "./CustomGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports